export const AUTH_TOKEN_KEY = "authToken";
export const USER_DATA_KEY = "userData";
export const USER_ROLE_KEY = "userType";

export function setAuthData({ token, user }) {
    if (token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    }

    if (user) {
        localStorage.setItem(USER_DATA_KEY, JSON.stringify(user));

        // Some APIs return the role as user_type, some as role.
        const role = user.user_type || user.userType || user.role;
        if (role) {
            localStorage.setItem(USER_ROLE_KEY, role);
        }
    }
}

export function getAuthToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function getUserData() {
    const d = localStorage.getItem(USER_DATA_KEY);
    if (!d) return null;
    try {
        return JSON.parse(d);
    } catch {
        return null;
    }
}

export function getUserRole() {
    const role = localStorage.getItem(USER_ROLE_KEY);
    if (role) return role;
    const user = getUserData();
    return user?.user_type || user?.userType || user?.role || null;
}

export function isAuthenticated() {
    return Boolean(getAuthToken());
}

export function logout() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(USER_DATA_KEY);
    localStorage.removeItem(USER_ROLE_KEY);
    localStorage.removeItem("persistentAuth");
}
